import React, {useState} from 'react';
import { useTranslation } from 'react-i18next';
import locationIcon from "../../assets/images/location_pin.svg"
import mailIcon from "../../assets/images/mail.svg"
import phoneIcon from "../../assets/images/phone.svg"
import SlideUp from "../ui/SlideUp";
import emailjs from '@emailjs/browser';
import settings from "../../constants/settings";

const Contact = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMsg, setSuccessMsg] = useState('');
  const [messageColor, setMessageColor] = useState('');

  const validate = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = t('common.fieldRequired');
    if (!formData.phone.trim()) newErrors.phone = t('common.fieldRequired');
    if (!formData.email.trim()) newErrors.email = t('common.fieldRequired');
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'This field is invalid';
    if (!formData.subject.trim()) newErrors.subject = t('common.fieldRequired');
    if (!formData.message.trim()) newErrors.message = t('common.fieldRequired');
    return newErrors;
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id.toLowerCase()]: e.target.value });
  };

  // Helper functions
  const showStatusMessage = (message, type) => {
    setErrors({}); // Clear previous errors
    setMessageColor(type === 'success' ? 'text-green-600' : 'text-red-600');
    setSuccessMsg(message);

    // Clear message after 5 seconds
    const timer = setTimeout(() => {
      setSuccessMsg('');
      setMessageColor('');
      clearTimeout(timer);
    }, 5000);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSubmitting(true);
    try {
      await emailjs.send(
        settings.emailService.serviceId,
        settings.emailService.templateId,
        formData,
        { publicKey: settings.emailService.publicKey }
        );
      // Handle success
      showStatusMessage('Your message has been sent! We will get back to you soon.', 'success');
      setFormData({ name: '', phone: '', email: '', subject: '', message: '' });
    } catch (err) {
      // console.error('Email send failed:', err);
      showStatusMessage('Something went wrong. Please try again later.', 'error');
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div>

      <div className="py-14">
        <div className="md:w-theme-container w-mobile-container mx-auto mb-20">
          <SlideUp
            duration={1}
          >
            <div className="text-center text-2xl my-12">{t('common.contact')}</div>
          </SlideUp>
          <SlideUp>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
              <div className="flex justify-between items-center h-28 bg-white border-l-4 border-theme-color rounded-xl shadow-2xl">
                <div className="w-[18%] h-28 flex items-center justify-center">
                  <img
                    className="md:w-12 md:h-12 w-9 h-9"
                    src={locationIcon}
                    alt="Location Pin"
                  />
                </div>
                <div className="w-[80%] h-28 flex items-center">
                  <div className="md:text-base text-sm">{t('common.addressDescription')}</div>
                </div>
              </div>
              <div className="flex justify-between items-center h-28 bg-white border-l-4 border-theme-color rounded-xl shadow-2xl">
                <div className="w-[18%] h-28 flex items-center justify-center">
                  <img
                    className="md:w-11 md:h-11 w-8 h-8"
                    src={mailIcon}
                    alt="phone Icon"
                  />
                </div>
                <div className="w-[87%] h-28 flex flex-col justify-center gap-2">
                  <a href='mailto:info@mesoft.ae' className="md:text-base text-sm">info@mesoft.ae</a>
                  {/*<div className="md:text-base text-sm">contact@mesoft.ae</div>*/}
                </div>
              </div>
              <div className="flex justify-between items-center h-28 bg-white border-l-4 border-theme-color rounded-xl shadow-2xl">
                <div className="w-[18%] h-28 flex items-center justify-center">
                  <img
                    className="md:w-11 md:h-11 w-8 h-8"
                    src={phoneIcon}
                    alt="Location Pin"
                  />
                </div>
                <div className="w-[87%] h-28 flex flex-col justify-center gap-2">
                  <div className="md:text-base text-sm">+971 4 2829 613  |  +971 4 2821 944</div>
                  <div className="md:text-base text-sm">+971 50 570 7868 ( WhatsApp )</div>
                </div>
              </div>
            </div>
          </SlideUp>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10">
            <div className="w-full">
              <SlideUp
                duration={1.3}
              >
                <div className="card px-5 pt-8 pb-4 w-full bg-white rounded-xl shadow-2xl">
                  <form
                    onSubmit={handleSubmit}
                  >
                    <div className="text-center my-5 text-xl font-bold text-black">{t('common.getInTouch')}</div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mt-8 mb-5">
                      <div className="form-group">
                        <label className="text-start text-black inline" htmlFor="Name" >{t('common.name')}</label>
                        {errors.name && <p className="text-red-500 ml-3 text-sm inline">{errors.name}</p>}
                        <input
                          type="text"
                          id="Name"
                          name="name"
                          className="w-full p-[10px] outline-none bg-slate-100 focus:outline-none focus:border-none focus:ring-0 hover:border-none rounded text-black"
                          value={formData.name}
                          onChange={handleChange}
                        />

                      </div>
                      <div className="form-group">
                        <label className="text-start text-black inline" htmlFor="Phone" >{t('common.phone')}</label>
                        {errors.phone && <p className="text-red-500 ml-3 text-sm inline">{errors.phone}</p>}
                        <input
                          type="text"
                          className="w-full p-[10px] outline-none bg-slate-100 focus:outline-none focus:border-none focus:ring-0 hover:border-none rounded text-black"
                          id="Phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-5 mb-5">
                      <div className="form-group">
                        <label className="text-start text-black inline" htmlFor="Email" >{t('common.email')}</label>
                        {errors.email && <p className="text-red-500 ml-3 text-sm inline">{errors.email}</p>}
                        <input
                          type="email"
                          className="w-full p-[10px] outline-none bg-slate-100 focus:outline-none focus:border-none focus:ring-0 hover:border-none rounded text-black"
                          id="Email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-5 mb-5">
                      <div className="form-group">
                        <label className="text-start text-black inline" htmlFor="Subject" >{t('common.subject')}</label>
                        {errors.subject && <p className="text-red-500 ml-3 text-sm inline">{errors.subject}</p>}
                        <input
                          type="text"
                          className="w-full p-[10px] outline-none bg-slate-100 focus:outline-none focus:border-none focus:ring-0 hover:border-none rounded text-black"
                          id="Subject"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-5 mb-5">
                      <div className="form-group">
                        <label className="text-start text-black inline" htmlFor="Message" >{t('common.message')}</label>
                        {errors.message && <p className="text-red-500 ml-3 text-sm inline">{errors.message}</p>}
                        <textarea
                          maxLength={255}
                          className="w-full p-[10px] outline-none bg-slate-100 focus:outline-none focus:border-none focus:ring-0 hover:border-none rounded text-black"
                          id="Message"
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          rows={5}
                        ></textarea>
                      </div>
                    </div>
                    <button
                      type={"submit"}
                      className="w-full mt-8 h-10 rounded bg-theme-color text-white text-center flex justify-center items-center"
                    >{isSubmitting ? 'Sending...' : t('common.submit')}</button>
                    <div className={`flex items-center justify-center h-6 mt-5 bg-yellow-3000 text-center ${messageColor}`}>
                      {successMsg && <p>{successMsg}</p>}
                    </div>
                  </form>
                </div>
              </SlideUp>
            </div>
            <div className="w-full h-auto md:h-[680px] rounded-xl overflow-hidden">
              <SlideUp
                duration={1.4}
              >
                {/*<img*/}
                {/*  className="w-full rounded-xl"*/}
                {/*  src={contactMap}*/}
                {/*  alt=""*/}
                {/*/>*/}
                <iframe
                  className="w-full h-svh rounded-xl border-0"
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d4477.701055213561!2d55.33769317608363!3d25.254681929368758!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5d1e3cff5b97%3A0xca720218c4ca13d!2sMesoft%20Business%20Solutions%20L.L.C.!5e1!3m2!1sen!2sae!4v1748521946232!5m2!1sen!2sae"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Google Maps Location"
                ></iframe>
              </SlideUp>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;